import { toast } from 'react-toastify';

export const shareMap = () => {
  // mixpanelClient.track('share_map_clicked');
  // copy current url to clipboard
  let url = window.location.href;

  // replace last part of url with overview
  const urlParts = url.split('/');

  // remove because we now point to roadmap page
  // urlParts[urlParts.length - 1] = 'overview';

  if (urlParts.length === 6) { // 6 means it has a content slug
    urlParts.pop();
  }

  url = urlParts.join('/');

  navigator.clipboard.writeText(url);
  toast.info('Map Link copied to clipboard', {
    toastId: 'MAP_LINK_COPIED',
    theme: 'dark',
  });
};
